import {View, Text, TouchableOpacity} from 'react-native';
import React from 'react';
import FontAwesome6 from 'react-native-vector-icons/FontAwesome6';
import {Colors} from '../../constants/Colors';

interface ISearchHeader {
  onPress: () => void;
  title?: string;
  mb?: number;
  mt?: number;
  ph?: number;
}

const SearchHeader = ({onPress, title, fs = 20, mb = 30, mt = 0, ph = 0,}: ISearchHeader) => {
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: mb,
        paddingHorizontal: ph,
        marginTop: mt,
      }}>
      <View
        style={{
          position: 'absolute',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          top: 6,
        }}>
        <Text
          style={{
            fontSize: fs,
            fontFamily: 'TCCC-UnityText Regular',
            textAlign: 'center',
            fontWeight: 'bold',
            lineHeight: 19,
            color: 'black',
            right: ph ? -1 * (ph/2) : 0,
          }}>
          {title}
        </Text>
      </View>
      <TouchableOpacity onPress={onPress}>
        <FontAwesome6
          name="arrow-left"
          color={Colors.RedPallete.red}
          size={22}
        />
      </TouchableOpacity>
    </View>
  );
};

export default SearchHeader;
